<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getOpenid,getSignUpInfo } from './utils/actions'
import { isWeixin, urlGet,config } from './utils/common'
export default {
  name: 'App',
  created () {
     this.setStoreSession();
     this.getconfigInfo();
  },
  methods: {
    async getconfigInfo(){
      let json = await getSignUpInfo({});
      if(!json) return;
      this.$store.commit('TERANT_INFO', json.data.app_info) // 租户信息
    },
    /*
    token替换openid作为唯一标识符
    目前openid 的逻辑暂时无用
    暂保留以便如后续增加微信服务相关需求
    **/
    initPage(appid){
        if (isWeixin() && !localStorage.getItem('recruit_openid')) {
        if (!urlGet().code) {
            let baseUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(`${location.protocol}${config.h5Url}/driver-recruit/index.html#/index`)}&response_type=code&scope=snsapi_base&state=null#wechat_redirect`
            location.href = baseUrl;
        } else {
          getOpenid({
            code: urlGet().code
          }).then((data) => {
            let openid = data.data.openid
            // this.$store.commit('OPENID', openid)
          })
        }
      } else {
        if (location.hash == '#/') {
          this.$router.push({path: 'index'})
        }
      }
    },
    setStoreSession () {
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem('store'))
          )
        )
      }
      /* 在页面刷新时将vuex里的信息保存到sessionStorage里 */
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue